
import FeesListView from '@/app/views/settings/FeesListView.vue';
import { Client, FeePaymentType } from 'ah-api-gateways';
import { BModal } from 'bootstrap-vue';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  components: {
    FeesListView,
  },
})
export default class ClientFeeInfo extends Vue {
  $refs!: {
    paymentFeesEditModal: BModal;
    fundingFeesEditModal: BModal;
  };

  @Prop({ required: true }) client!: Client;

  get feePaymentType() {
    return FeePaymentType;
  }

  showPaymentFeeModal() {
    this.$refs.paymentFeesEditModal.show();
  }

  showFundingFeeModal() {
    this.$refs.fundingFeesEditModal.show();
  }
}
